import { AccordionButton, Text } from '@chakra-ui/react';
import { type FC } from 'react';

import { Icon } from '$/components/common/Icon';

interface Props {
  label: string;
  isExpanded: boolean;
  compactMode?: boolean;
}

export const AccordionHeader: FC<Props> = ({
  label,
  isExpanded,
  compactMode = false,
}) => {
  return (
    <AccordionButton
      justifyContent='space-between'
      w='full'
      pb={compactMode ? '0' : undefined}
      fontSize='sm'
    >
      <Text fontWeight='bold'>{label}</Text>
      <Icon
        icon='chevron_down'
        transform={isExpanded ? 'rotate(180deg)' : ''}
        w='12px'
        transition='transform 0.2s ease'
      />
    </AccordionButton>
  );
};
